import { render, staticRenderFns } from "./goodsOrderList.vue?vue&type=template&id=f00ae216&scoped=true"
import script from "./goodsOrderList.vue?vue&type=script&lang=ts"
export * from "./goodsOrderList.vue?vue&type=script&lang=ts"
import style0 from "./goodsOrderList.vue?vue&type=style&index=0&id=f00ae216&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00ae216",
  null
  
)

export default component.exports